/* FRANK14 · bold — i capi visti di recente.
   Due mestieri:
   1. sulla scheda di un capo, segna il codice fra quelli visti (solo sul
      dispositivo di chi guarda: niente esce da lì);
   2. dove c'è la striscia [data-visti], la riempie rileggendo i capi dal
      negozio — prezzo, sconto e disponibilità di adesso, non quelli di ieri.
   Se non c'è niente da mostrare la striscia resta nascosta e non lascia
   un buco nella pagina. */
(function () {
  var CHIAVE = 'frank14:visti';
  var QUANTI = 8;

  function leggi() {
    try {
      var grezzo = window.localStorage.getItem(CHIAVE);
      var lista = grezzo ? JSON.parse(grezzo) : [];
      return Object.prototype.toString.call(lista) === '[object Array]' ? lista : [];
    } catch (e) { return []; }
  }

  function scrivi(lista) {
    try { window.localStorage.setItem(CHIAVE, JSON.stringify(lista.slice(0, 20))); } catch (e) {}
  }

  /* ---------- 1. segnare il capo aperto ---------- */
  var scheda = document.querySelector('product-info.pr[data-url]');
  var codiceQui = null;
  if (scheda) {
    var pezzi = (scheda.getAttribute('data-url') || '').split('/products/');
    codiceQui = pezzi.length > 1 ? pezzi[1].split('?')[0].replace(/\/$/, '') : null;
    if (codiceQui) {
      var lista = leggi().filter(function (c) { return c !== codiceQui; });
      lista.unshift(codiceQui);
      scrivi(lista);
    }
  }

  /* ---------- 2. riempire la striscia ---------- */
  var striscia = document.querySelector('[data-visti]');
  if (!striscia) return;
  var contenitore = striscia.querySelector('[data-visti-lista]');
  var codici = leggi().filter(function (c) { return c && c !== codiceQui; }).slice(0, QUANTI);
  if (!codici.length) return;

  function soldi(centesimi) {
    /* come lo scrive il negozio: €29,90 — non «29,90 €» come farebbe Intl */
    var n = (centesimi / 100).toFixed(2).replace('.', ',');
    var pezzi = n.split(',');
    pezzi[0] = pezzi[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + pezzi.join(',');
  }

  function scheggia(p) {
    var a = document.createElement('a');
    a.className = 'vst__capo' + (p.available ? '' : ' vst__capo--finito');
    a.href = '/products/' + p.handle;

    var foto = document.createElement('span');
    foto.className = 'vst__foto';
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2');
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 400; img.height = 500;
      foto.appendChild(img);
    }
    if (!p.available) {
      var velo = document.createElement('span');
      velo.className = 'vst__finito b-eti';
      velo.textContent = 'Esaurito';
      foto.appendChild(velo);
    }
    a.appendChild(foto);

    var testo = document.createElement('span');
    testo.className = 'vst__testo';
    var nome = document.createElement('span');
    nome.className = 'vst__nome';
    nome.textContent = p.title;
    var prezzo = document.createElement('span');
    prezzo.className = 'vst__prezzo b-num';
    prezzo.textContent = soldi(p.price);
    testo.appendChild(nome);
    testo.appendChild(prezzo);
    a.appendChild(testo);
    return a;
  }

  Promise.all(codici.map(function (c) {
    return fetch('/products/' + c + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  })).then(function (capi) {
    var vivi = capi.filter(Boolean);
    if (vivi.length < 2) return;                 /* uno solo non è una striscia */
    /* i capi spariti dal negozio si tolgono anche dalla memoria */
    var restano = vivi.map(function (p) { return p.handle; });
    scrivi(leggi().filter(function (c) { return restano.indexOf(c) !== -1 || c === codiceQui; }));

    vivi.forEach(function (p) {
      var li = document.createElement('li');
      li.className = 'vst__cella';
      li.appendChild(scheggia(p));
      contenitore.appendChild(li);
    });
    striscia.hidden = false;
  });

  var pulisci = striscia.querySelector('[data-visti-pulisci]');
  if (pulisci) {
    pulisci.addEventListener('click', function () {
      try { window.localStorage.removeItem(CHIAVE); } catch (e) {}
      striscia.hidden = true;
    });
  }
})();
